export class MockGeoLocation {
    clearWatch(watchId: number): void { }
    getCurrentPosition(successCallback: PositionCallback, errorCallback?: PositionErrorCallback | null, options?: PositionOptions): void {
        successCallback(
            {
                coords: { latitude: 38.5, longitude: -92.13 },
                timestamp: Date.now()
            } as GeolocationPosition)
    }
    watchPosition(successCallback: PositionCallback, errorCallback?: PositionErrorCallback | null, options?: PositionOptions): number {
        return 0;
    }
}

//38.54945, -92.04826